import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getArchive, updateArchive } from "../../../api/archives.api";
import ArchiveEditor from "../../../components/archive/ArchiveEditor";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetArchive } from "../../../models/archives.model";

interface IMatch {
  archiveCode: string;
}

const ArchiveManageEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const archiveCode = Number(match.params.archiveCode);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetArchive>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (archiveCode) {
      execute(getArchive('OP', archiveCode));
    }
  }, [archiveCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/archive/manage${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    submitExecute(updateArchive('OP', data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-archive-big.svg"
        parentMenu={t('common.menu.resources')}
        currentMenu={t('archive.manage.title3')}
      />
      <ArchiveEditor
        codeId="BR0011"
        archiveCode={archiveCode}
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default ArchiveManageEdit;

